import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4" data-id="element-138">
      <div className="max-w-5xl mx-auto" data-id="element-139">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-140">
          <FadeIn className="order-2 lg:order-1" data-id="element-141">
            <span className="inline-block py-1 px-3 rounded-full bg-gold-100 text-warmBrown-700 text-sm font-semibold tracking-wide mb-6" data-id="element-142">
              Para Madres Latinas en USA
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-143">
              El Protocolo de los 7 Segundos: Cómo lograr que tus hijos te
              escuchen sin tener que gritar (ni perder los nervios)
            </h1>
            <p className="text-xl md:text-2xl text-warmBrown-700 mb-8 leading-relaxed" data-id="element-144">
              La guía práctica para recuperar la paz en casa y criar hijos
              seguros sin usar la "chancla" ni las amenazas vacías.
            </p>
            <Button scrollTo="offer" className="w-full sm:w-auto text-xl py-5 px-10 shadow-lg shadow-terracotta/30" data-id="element-145">
              ¡SÍ, QUIERO CRIAR CON CALMA!
            </Button>
            <p className="mt-4 text-sm text-warmBrown-500 italic" data-id="element-146">
              *Acceso instantáneo. Descarga inmediata.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="order-1 lg:order-2 relative" data-id="element-147">
            <div className="absolute inset-0 bg-gold-200 rounded-3xl transform rotate-3 scale-105 opacity-50" data-id="element-148"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cRC7uk93wUusfkRb6GiekY/heylloyd-image-1772077517193.png" alt="Madre e hija abrazándose con amor y calma" className="relative z-10 rounded-3xl shadow-2xl w-full object-cover aspect-[4/3]" data-id="element-149" />
          </FadeIn>
        </div>
      </div>
    </section>;
}